import { fromGid } from '@/lib/shopify/gid';
import { initElevarDataLayer } from '@/lib/elevar/shared';
import { toCents } from '@/utils/utilities.mjs';

/** Pushes the legacy theme's `{ pageType }` object on non-PDP routes (defaults to `'page'`). */
export function elevarPageTypePage(pageType = 'page') {
  if (!initElevarDataLayer()) return;

  window.ElevarDataLayer.push({ pageType });
}

/**
 * Pushes the legacy theme's plain `pageType` objects (no `event` key) that the
 * GTM container reads directly as Data Layer Variables. Not part of the Elevar
 * `dl_*` spec — kept only for GTM tags built against the old theme's shape.
 */
export default function elevarPageType(productData, selectedVariant, pricing) {
  if (!initElevarDataLayer()) return;

  const { shopifyProduct } = productData || {};
  const variant = selectedVariant || shopifyProduct?.variants?.[0];

  if (!variant || !shopifyProduct) return;

  const { sale } = pricing.variant(variant);
  const [option_1 = null, option_2 = null, option_3 = null] = (
    variant?.selectedOptions || []
  ).map((option) => option.value);

  window.ElevarDataLayer.push({ pageType: 'product' });

  window.ElevarDataLayer.push({
    pageType: 'productDetail',
    productId: Number(fromGid(shopifyProduct?.id || '')),
    productType: shopifyProduct?.productType || '',
    productHandle: shopifyProduct?.handle || '',
    variantId: Number(fromGid(variant?.id || '')),
    priceInCents: String(toCents(sale ?? variant?.price?.amount ?? 0)),
    sku: variant?.sku || '',
    option_1,
    option_2,
    option_3,
  });
}
